
















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class TabsNavigation extends Vue {
  @Prop({ default: [] }) tabs!: { label: string; value: string }[];
  @Prop({ default: '' }) activeTab?: string;
}
